/**
 * Mounts the per-user notification realtime subscription exactly once,
 * inside the auth + react-query providers. Render at most once in the tree.
 */
import { useNotificationRealtime } from "@/hooks/useNotificationRealtime";

export function NotificationRealtimeBridge() {
  useNotificationRealtime();
  return null;
}